<!--
 * @Author: Shber
 * @Date: 2023-02-07 10:33:18
 * @LastEditors: Shber
 * @LastEditTime: 2023-05-19 17:31:01
 * @Description:
-->
<template>
  <div>
    <div v-lazy-container="{ selector: '.tit_pl img' }" class="tit_pl">
      <img data-src="https://static.mingchu.co/webapp/images/img/icon_talk.png" alt="">
      {{ $t('articles.comments') }}
      <span>({{ commentNum }})</span>
    </div>
    <ul v-if="isGteatChefbrowser" class="pl_list">
      <li v-for="(item,index) in comment" :key="index">
        <a :href="item.link" class="pl_hd">
          <img v-lazy="item.head_pic" alt="">
          <img v-if="item.user_icon != ''" :src="item.user_icon" class="pl_v">
        </a>
        <div class="ova">
          <div class="hd">
            <div class="hd_t">
              <em>{{ item.nickname }}
                <img v-if="item.members.length > 0" :src="item.members[0].pic">
              </em>
            </div>
            <p>{{ item.duty }}</p>
          </div>
          <div class="bd">
            <span v-if="item.is_hot == 1" class="ico_hot">热门评论 </span>
            <em style="white-space:pre-wrap;" @click="postComment(item)" v-html="textReplace(item.comment)" />
          </div>
          <div class="bdbottom">
            <div class="sq_time">{{ timestampFormat(item.addtime) }}</div>
            <div class="zan_good">
              <span @click="postComment(item)">{{ $t('articles.reply') }}</span>
              <span @click="postPraise(item)">
                <img v-if="item.ps == 0" src="https://static.mingchu.co/webapp/images/zan/icon_good.png">
                <img v-else src="https://static.mingchu.co/webapp/images/zan/icon_ingood.png"> {{ item.zan }}
              </span>
            </div>
          </div>
          <dl v-if="item.reply.length >0" class="list_dl">
            <dd v-for="(arr,index) in item.reply" :key="index">
              <template v-if="index<item.longMore">
                <span v-if="arr.nickname== arr.rnickname">
                  <a :href="arr.link">{{ arr.nickname }}:</a>
                </span>
                <dt v-else>
                  <span> <a :href="arr.link">{{ arr.nickname }}</a></span>
                  <span @click="postComment(item)">{{ $t('articles.reply') }}</span>
                  <span> <a :href="arr.rlink">{{ arr.rnickname }}</a>:</span>
                </dt>
                <dt @click="postComment(item,arr)" v-html="textReplace(arr.content)" />
              </template>
            </dd>
            <dd v-if="item.more" class="list_more" @click="showMore(item)">剩余{{ item.reply.length -3 }}条回复</dd>
          </dl>
        </div>
      </li>
    </ul>
    <ul v-else class="pl_list">
      <li v-for="(item,index) in comment" :key="index">
        <template v-if="index<3">
          <a :href="item.link" class="pl_hd"><img v-lazy="item.head_pic" alt=""> <img v-if="item.user_icon != ''" :src="item.user_icon" class="pl_v"></a>
          <div class="ova">
            <div class="hd">
              <div class="hd_t">
                <em>{{ item.nickname }}  <img v-if="item.members.length > 0" :src="item.members[0].pic"> </em>
              </div>
              <p>{{ item.duty }}</p>
            </div>
            <div class="bd">
              <span v-if="item.is_hot == 1" class="ico_hot">热门评论 </span> <em style="white-space:pre-wrap;" @click="postComment(item)" v-html="textReplace(item.comment)" />
            </div>
            <div class="bdbottom">
              <div class="sq_time">{{ timestampFormat(item.addtime) }}</div>
              <div class="zan_good">
                <span @click="postComment(item)">{{ $t('articles.reply') }}</span>
                <span @click="postPraise(item)">
                  <img v-if="item.ps == 0" src="https://static.mingchu.co/webapp/images/zan/icon_good.png">
                  <img v-else src="https://static.mingchu.co/webapp/images/zan/icon_ingood.png"> {{ item.zan }}
                </span>
              </div>
            </div>
            <dl v-if="item.reply.length" class="list_dl">
              <dd v-for="(arr,index) in item.reply" :key="index">
                <template v-if="index<item.longMore">
                  <span v-if="arr.nickname== arr.rnickname">
                    <a :href="arr.link">{{ arr.nickname }}:</a>
                  </span>
                  <dt v-else>
                    <span><a :href="arr.link">{{ arr.nickname }}</a></span>
                    <span @click="postComment(item,arr)">{{ $t('articles.reply') }}</span>
                    <span><a :href="arr.rlink">{{ arr.rnickname }}</a>:</span>
                  </dt>
                  <dt @click="postComment(item,arr)" v-html="textReplace(arr.content)" />
                </template>
              </dd>
              <dd v-if="item.more" class="list_more" @click="showMore(item)">剩余{{ item.reply.length -3 }}条回复</dd>
            </dl>
          </div>
        </template>
      </li>
    </ul>
  </div>

</template>
<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { emoji } from './emoji'
import { useI18n } from 'vue-i18n/index'// 要在js中使用国际化
import config from '@/config/config'
import utils from '@/utils/utils'
import { articles } from '@/api/api'
import { checkloginCallback } from '@/utils'

const router = useRouter()
const { t } = useI18n() // 国际化方法
const props = defineProps({
  comment: { // 评论的相关数据
    type: Array,
    default: () => []
  },
  commentNum: { // 评论数量
    type: Number,
    default: 0
  }
})

const pathId = ref(router.currentRoute.value.query.id)

const isGteatChefbrowser = ref(utils.isGteatChefbrowser())
console.log('isGteatChefbrowser', isGteatChefbrowser.value)

const postComment = (colum, reply) => { // 发布评论与回复
  console.log(colum, reply)
  // const _self = this
  reply = typeof (reply) === 'undefined' ? '' : reply
  const comment_input_text = reply === '' ? '回复' + colum.nickname : '回复' + reply.nickname
  const nickname = reply === '' ? colum.nickname : reply.nickname
  const ruid = reply === '' ? colum.uid : reply.uid
  checkloginCallback(
    function() { // 统一的接口请求方法
      utils.getAuth().then(res_auth => {
        res_auth = JSON.parse(res_auth)
        if (res_auth.success === 'yes') {
          const data = {
            uid: res_auth.data.uid,
            comment_input_text: comment_input_text,
            id: pathId.value,
            pid: '0',
            type: '6',
            comment: colum.comment.toString(),
            rid: colum.id.toString(),
            ruid: reply === '' ? colum.uid.toString() : reply.uid.toString()
          }
          utils.comment(JSON.stringify(data)).then(res_comment => {
            res_comment = JSON.parse(res_comment)

            // let replyItem = {}
            const replyItem = {
              content: res_comment.data.comment,
              id: res_comment.data.id,
              nickname: res_auth.data.nick_name,
              rnickname: nickname,
              link: config.webapplink + '/userview?id=' + res_auth.data.uid,
              rlink: config.webapplink + '/userview?id=' + ruid,
              ruid: ruid,
              uid: res_auth.data.uid
            }
            showMore(colum)
            colum.reply.push(replyItem)
          })
        }
      })
    }
  )
}
const postPraise = (list) => { // 点赞
  checkloginCallback(
    function() { // 统一的接口请求方法
      utils.getAuth().then(res => {
        res = JSON.parse(res)
        if (res.success === 'yes') {
          utils.getEnv().then(res_env => {
            res_env = JSON.parse(res_env)
            const data = {
              type: 9,
              id: list.id,
              uid: res.data.uid,
              token: res.data.auth_token,
              plant: res_env.data.plant
            }
            articles.praise(data).then(res_praise => {
              if (res_praise.status_code == '200' && list.ps != 1) {
                list.ps = 1
                list.zan = Number(list.zan) + 1
                if (JSON.stringify(res_praise.alert_box) != '{}') {
                  utils.alertBox(JSON.stringify(res_praise.alert_box))
                }
              }
            })
          })
        }
      })
    })
}
const showMore = (item) => {
  item.more = false
  item.longMore = 100
}
const textReplace = (str) => { // 新替换表情-表情包与app同步
  emoji.forEach((item, index) => {
    if (str.indexOf(item.name) != -1) {
      const regex = new RegExp(item.replace, 'g')
      str = str.replace(regex, item.emoji)
    }
  })
  return str
}

// const textReplace = (str) => { // 老替换表情
//   const patternsReplace = ['\\[微笑\\]', '\\[撇嘴\\]', '\\[色\\]', '\\[发呆\\]', '\\[得意\\]', '\\[流泪\\]', '\\[害羞\\]', '\\[闭嘴\\]', '\\[睡\\]', '\\[大哭\\]', '\\[尴尬\\]', '\\[发怒\\]', '\\[调皮\\]', '\\[呲牙\\]', '\\[惊讶\\]', '\\[难过\\]', '\\[酷\\]', '\\[冷汗\\]', '\\[抓狂\\]', '\\[吐\\]', '\\[偷笑\\]', '\\[愉快\\]', '\\[白眼\\]', '\\[傲慢\\]', '\\[饥饿\\]', '\\[困\\]', '\\[惊恐\\]', '\\[流汗\\]', '\\[憨笑\\]', '\\[悠闲\\]', '\\[奋斗\\]', '\\[咒骂\\]', '\\[疑问\\]', '\\[嘘\\]', '\\[晕\\]', '\\[疯了\\]', '\\[衰\\]', '\\[骷髅\\]', '\\[敲打\\]', '\\[再见\\]', '\\[擦汗\\]', '\\[抠鼻\\]', '\\[鼓掌\\]', '\\[糗大了\\]', '\\[坏笑\\]', '\\[左哼哼\\]', '\\[右哼哼\\]', '\\[哈欠\\]', '\\[鄙视\\]', '\\[委屈\\]', '\\[快哭了\\]', '\\[阴险\\]', '\\[亲亲\\]', '\\[吓\\]', '\\[可怜\\]', '\\[菜刀\\]', '\\[西瓜\\]', '\\[啤酒\\]', '\\[篮球\\]', '\\[乒乓\\]', '\\[咖啡\\]', '\\[饭\\]', '\\[猪头\\]', '\\[玫瑰\\]', '\\[凋谢\\]', '\\[嘴唇\\]', '\\[爱心\\]', '\\[心碎\\]', '\\[蛋糕\\]', '\\[闪电\\]', '\\[炸弹\\]', '\\[刀\\]', '\\[足球\\]', '\\[瓢虫\\]', '\\[便便\\]', '\\[月亮\\]', '\\[太阳\\]', '\\[礼物\\]', '\\[拥抱\\]', '\\[强\\]', '\\[弱\\]', '\\[握手\\]', '\\[胜利\\]', '\\[抱拳\\]', '\\[勾引\\]', '\\[拳头\\]', '\\[差劲\\]', '\\[爱你\\]', '\\[NO\\]', '\\[OK\\]', '\\[笑脸\\]', '\\[生病\\]', '\\[破涕为笑\\]', '\\[吐舌\\]', '\\[emoji晕\\]', '\\[脸红\\]', '\\[恐惧\\]', '\\[失望\\]', '\\[眨眼\\]', '\\[满意\\]', '\\[无语\\]', '\\[恶魔\\]', '\\[鬼魂\\]', '\\[礼盒\\]', '\\[合十\\]', '\\[强壮\\]', '\\[钱\\]', '\\[气球\\]']
//   const patterns = ['[微笑]', '[撇嘴]', '[色]', '[发呆]', '[得意]', '[流泪]', '[害羞]', '[闭嘴]', '[睡]', '[大哭]', '[尴尬]', '[发怒]', '[调皮]', '[呲牙]', '[惊讶]', '[难过]', '[酷]', '[冷汗]', '[抓狂]', '[吐]', '[偷笑]', '[愉快]', '[白眼]', '[傲慢]', '[饥饿]', '[困]', '[惊恐]', '[流汗]', '[憨笑]', '[悠闲]', '[奋斗]', '[咒骂]', '[疑问]', '[嘘]', '[晕]', '[疯了]', '[衰]', '[骷髅]', '[敲打]', '[再见]', '[擦汗]', '[抠鼻]', '[鼓掌]', '[糗大了]', '[坏笑]', '[左哼哼]', '[右哼哼]', '[哈欠]', '[鄙视]', '[委屈]', '[快哭了]', '[阴险]', '[亲亲]', '[吓]', '[可怜]', '[菜刀]', '[西瓜]', '[啤酒]', '[篮球]', '[乒乓]', '[咖啡]', '[饭]', '[猪头]', '[玫瑰]', '[凋谢]', '[嘴唇]', '[爱心]', '[心碎]', '[蛋糕]', '[闪电]', '[炸弹]', '[刀]', '[足球]', '[瓢虫]', '[便便]', '[月亮]', '[太阳]', '[礼物]', '[拥抱]', '[强]', '[弱]', '[握手]', '[胜利]', '[抱拳]', '[勾引]', '[拳头]', '[差劲]', '[爱你]', '[NO]', '[OK]', '[笑脸]', '[生病]', '[破涕为笑]', '[吐舌]', '[emoji晕]', '[脸红]', '[恐惧]', '[失望]', '[眨眼]', '[满意]', '[无语]', '[恶魔]', '[鬼魂]', '[礼盒]', '[合十]', '[强壮]', '[钱]', '[气球]']
//   const replace = ['<img src="https://static.mingchu.co/webapp/images/qq_face/d_001.png">', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_002.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_003.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_004.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_005.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_006.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_007.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_008.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_009.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_010.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_011.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_012.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_013.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_014.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_015.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_016.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_017.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_018.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_019.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_020.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_021.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_022.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_023.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_024.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_025.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_026.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_027.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_028.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_029.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_030.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_031.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_032.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_033.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_034.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_035.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_036.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_037.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_038.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_039.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_040.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_041.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_042.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_043.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_044.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_045.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_046.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_047.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_048.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_049.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_050.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_051.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_052.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_053.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_054.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_055.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_056.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_057.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_058.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_059.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_060.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_061.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_062.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_063.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_064.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_065.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_066.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_067.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_068.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_069.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_070.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_071.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_072.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_073.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_074.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_075.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_076.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_077.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_078.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_079.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_080.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_081.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_082.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_083.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_084.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_085.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_086.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_087.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_088.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_089.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/d_090.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_1.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_2.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_3.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_4.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_5.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_6.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_7.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_8.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_9.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_10.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_11.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_12.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_13.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_14.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_15.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_16.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_17.png"/>', '<img src="https://static.mingchu.co/webapp/images/qq_face/dd_19.png"/>']
//   patterns.forEach((res, index) => {
//     if (str.indexOf(res) != -1) {
//       str = str.replace(new RegExp(patternsReplace[index], 'g'), replace[index])
//     }
//   })
//   return str
// }

const timestampFormat = (timestamp) => { // 格式化时间
  function zeroize(num) {
    return (String(num).length == 1 ? '0' : '') + num
  }

  var curTimestamp = parseInt(new Date().getTime() / 1000) // 当前时间戳
  var timestampDiff = curTimestamp - timestamp // 参数时间戳与当前时间戳相差秒数

  var curDate = new Date(curTimestamp * 1000) // 当前时间日期对象
  var tmDate = new Date(timestamp * 1000) // 参数时间戳转换成的日期对象

  var Y = tmDate.getFullYear()
  var m = tmDate.getMonth() + 1
  var d = tmDate.getDate()
  var H = tmDate.getHours()
  var i = tmDate.getMinutes()
  // var s = tmDate.getSeconds()

  if (timestampDiff < 60) { // 一分钟以内
    return t('articles.time') // 刚刚
  } else if (timestampDiff < 3600) { // 一小时前之内
    return Math.floor(timestampDiff / 60) + t('articles.time1') // 分钟前
  } else if (curDate.getFullYear() === Y && curDate.getMonth() + 1 === m && curDate.getDate() === d) {
    return t('articles.time2') + zeroize(H) + ':' + zeroize(i) // 今天
  } else {
    var newDate = new Date((curTimestamp - 86400) * 1000) // 参数中的时间戳加一天转换成的日期对象
    if (newDate.getFullYear() === Y && newDate.getMonth() + 1 === m && newDate.getDate() === d) {
      return t('articles.time3') + zeroize(H) + ':' + zeroize(i) // 昨天
    } else if (curDate.getFullYear() === Y) {
      return zeroize(m) + '.' + zeroize(d) + ' ' + zeroize(H) + ':' + zeroize(i)
    } else {
      return Y + '.' + zeroize(m) + '.' + zeroize(d)
    }
  }
}
</script>
